import { useCallback, useEffect } from "react";
import { Entity, EntityRelation } from "@backstage/catalog-model";
import { CatalogClient } from "@backstage/catalog-client";
import { handleError } from "../handlers";
import { useAsyncFn } from "react-use";
import { discoveryApiRef, useApi } from "@backstage/core";
import { useEntity } from "@backstage/plugin-catalog-react";
import { identityApiRef } from "@backstage/core-plugin-api";

export const useTeamMembers = () => {
  const discoveryApi = useApi(discoveryApiRef);
  const identityApi = useApi(identityApiRef);

  const e = useEntity();
  const entity: Entity = e.entity;

  const getTeamMembers = useCallback(async () => {
    try {
      const { token } = await identityApi.getCredentials();

      const teamEntities = entity?.relations?.filter(
        (relation: EntityRelation) => {
          return relation.type === "hasMember";
        }
      );

      const catalog = new CatalogClient({ discoveryApi });

      return await Promise.all(
        teamEntities!.map(async (member: EntityRelation) => {
          return await catalog.getEntityByRef(member.targetRef, { token });
        })
      );
    } catch (err: any) {
      return handleError(err);
    }
  }, [entity, identityApi, discoveryApi]);

  const [state, fetchTeamMembers] = useAsyncFn(async () => {
    return await getTeamMembers();
  }, []);

  useEffect(() => {
    fetchTeamMembers();
  }, [fetchTeamMembers]);

  return {
    loading: state.loading,
    error: state.error,
    value: state?.value,
    fetchTeamMembers,
  };
};
